import axios from "axios"
import { SOURCE_ORIGIN } from "@/constants"
import { resolveHttpTimeoutMs } from "@/utils/httpTimeout"

export const publicAemBaseUrl =
  process.env.NEXT_PUBLIC_PUBLISHERBASEURL ||
  process.env.NEXT_PUBLIC_AUTHORBASEURL ||
  ""
const httpTimeoutMs = resolveHttpTimeoutMs(
  process.env.NEXT_PUBLIC_HTTP_TIMEOUT_MS
)

const createSourceOriginInterceptor = fallbackOrigin => async config => {
  config.headers = config.headers || {}
  if (!config.headers["X-Source-Origin"]) {
    if (config.headers?.common?.["Ocp-Apim-Subscription-Key"]) {
      const browserOrigin =
        typeof window !== "undefined" ? window.location.origin : ""
      config.headers["X-Source-Origin"] =
        SOURCE_ORIGIN ?? browserOrigin ?? fallbackOrigin ?? ""
    }
  }
  return config
}

export const aemClientAxiosInstance = axios.create({
  baseURL: publicAemBaseUrl,
  timeout: httpTimeoutMs,
  headers: {
    "Content-type": "application/json",
    KohlerTarget: "AzureApp",
  },
})

aemClientAxiosInstance.interceptors.request.use(
  createSourceOriginInterceptor(publicAemBaseUrl)
)

export const callAemClientApi = async config => aemClientAxiosInstance(config)
